import React from 'react';
import PropTypes from 'prop-types';
import { adopt } from 'react-adopt';
import { Query } from '@apollo/react-components';
import gql from 'graphql-tag';
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';

import { ContributePageConsumer } from '../../context';
import Fundraiser from './fundraiser';

export const GET_FUNDRAISERS = gql`
    query FundraisersByCampaign($campaign: ID!) {
        fundraiserList: fundraisersByCampaign(campaignId: $campaign, limit: -1) {
            items {
                id
                isHidden
                user {
                    id
                    firstName
                    lastName
                    username
                    avatar {
                        id
                    }
                }
            }
        }
    }
`;

export const GET_FUNDRAISER = gql`
    query FundraiserByUsername($campaign: ID!, $username: String!) {
        fundraiser: fundraiserByUsername(campaignId: $campaign, username: $username) {
            id
            user {
                id
                firstName
                lastName
                username
                avatar {
                    id
                }
            }
        }
    }
`;

/* eslint-disable react/prop-types, react/destructuring-assignment */
const Wrapper = adopt(
    {
        context: <ContributePageConsumer />,
        fundraisersQuery: ({ context, render }) => (
            <Query query={GET_FUNDRAISERS} variables={{ campaign: context.campaign.id }}>
                {render}
            </Query>
        ),
        fundraiserQuery: ({ selectedUsername, context, render }) => (
            <Query
                skip={!selectedUsername}
                query={GET_FUNDRAISER}
                variables={{
                    username: selectedUsername,
                    campaign: context.campaign.id,
                }}
            >
                {render}
            </Query>
        ),
    },
    ({ context, fundraisersQuery, fundraiserQuery }) => ({
        context,
        error: fundraisersQuery.error || fundraiserQuery.error,
        loading: fundraisersQuery.loading || fundraiserQuery.loading,
        fundraisers: get(fundraisersQuery, 'data.fundraiserList.items', []),
        fundraiser: get(fundraiserQuery, 'data.fundraiser'),
    })
);
/* eslint-enable react/prop-types, react/destructuring-assignment */

const FundraiserContainer = ({ selected, ...props }) => (
    <Wrapper selectedUsername={selected}>
        {({ error, loading, fundraisers, fundraiser, context }) => {
            if (error) throw error;
            if (loading) return null;

            const selectable = fundraisers.filter(x => !x.isHidden);
            if (!selectable.length) return null;

            return (
                <Fundraiser
                    fundraisers={sortBy(selectable, ['user.firstName', 'user.lastName'])}
                    fundraiser={fundraiser}
                    isLocked={context.isReferrerLocked}
                    {...props}
                />
            );
        }}
    </Wrapper>
);

FundraiserContainer.propTypes = {
    selected: PropTypes.string,
};

FundraiserContainer.defaultProps = {
    selected: null,
};

export default FundraiserContainer;
